import { forwardRef } from "react";
import type { LinkItem } from "src/http/api-types";
import { useFormattedContent } from "src/shared/components/content";
import { useSportData } from "../../../hooks/useSportData";
import { StyledHeading, StyledTeamsSection } from "./styled-components";
import { TeamGroupingSection } from "./TeamGroupingSection";

interface Props {
  categoryName: Maybe<string>;
  teams: readonly LinkItem[];
}

/**
 * Section to Display All Teams Within a Sports League on the Sports League's Category Grouping Page
 */
export const TeamsSection = forwardRef<HTMLElement, Props>(({ categoryName, teams }, ref) => {
  const { leagues } = useSportData(teams);
  const headingContent = useFormattedContent("cid$#3092996#", [categoryName ?? ""]); // All {categoryName} Teams

  return (
    <StyledTeamsSection ref={ref}>
      <StyledHeading>{headingContent}</StyledHeading>
      {Object.entries(leagues).map(([key, league]) => (
        <TeamGroupingSection key={key} {...league} />
      ))}
    </StyledTeamsSection>
  );
});
TeamsSection.displayName = "TeamsSection";
